import { Button, Dialog, Spinner } from "@blueprintjs/core";
import { DatePicker } from "@blueprintjs/datetime";
import { IconNames } from "@blueprintjs/icons";
import autobind from "autobind-decorator";
import DateLabel from "core/components/label/DateLabel";
import Label from "core/components/label/Label";
import * as React from "react";
// import { FormattedDate } from "react-intl";
import { FlexCenter } from "../../common/fragments/Flex";
import { ButtonView } from "../../common/views/button/Button.view";
import { CardView } from "../../common/views/card/Card.view";
import HeadingView from "../../common/views/heading/Heading.view";
import { IPanelProps, Panel } from "../../core/decorators/Panel";
import ILocalCacheService from "../../core/service/cache/ILocalCacheService";
import FetchResolverService from "../../core/service/resolver/impl/FetchResolver.service";
import ServiceRegistry from "../../core/util/ServiceRegistry";
import TokenSession from "../../core/util/session/TokenSession";
import StringUtil from "../../core/util/StringUtil";
import { iDef } from "../../core/util/TypeUtils";
import labelProvider from './DateReminder.labels';
import DateReminderConfig from "./DateReminderConfig";
import { examDateMutation, examDateQuery } from "./queries";

const { Labels } = labelProvider;

interface IDateReminderState {
	newDate?: Date;
	date?: Date;
	prompt?: boolean;
}

// define global state so if there are multiple panels on the same page they dont all show popups.
interface IDateReminderSharedState {
	date?: Date;
	loading?: boolean;
	prompt?: boolean;
}

@Panel({id: "dateReminder", configClass: DateReminderConfig, sharedState: {date: undefined, loading: true, prompt: false}, labelProvider})
export class DateReminderPanel extends React.PureComponent<IPanelProps<DateReminderConfig, IDateReminderSharedState>, IDateReminderState> {

	constructor(props: IPanelProps<DateReminderConfig>) {
		super(props);

		this.state = {newDate: new Date()};
	}

	@autobind
	private handleChange(date: Date) {
		this.setState({newDate: date});
	}

	@autobind
	private setDialog(open: boolean) {
		this.setState({prompt: open});
	}

	private getStorageKey() {
		return StringUtil.format("exam:date:%s", TokenSession.getUserId().toString());
	}

	private setDate(value: Date) {
		const storageService = ServiceRegistry.get(ILocalCacheService);
		storageService.putString(this.getStorageKey(), value.toString());

		this.setState({date: value, prompt: false});
	}

	public componentDidMount() {
		const storageService = ServiceRegistry.get(ILocalCacheService);
		const date = storageService.getString(this.getStorageKey());

		if(iDef(date)) {
			this.setState({date: new Date(date), prompt: false});
		} else if(this.props.config.prompt) {
			this.setState({prompt: true});
		}
	}

	public render() {
		const { newDate, date, prompt } = this.state;

		const maxDate = new Date();

		// five years from now
		maxDate.setFullYear(maxDate.getFullYear() + 5);

		return (
			<div>
				<Dialog
					isOpen={prompt}
					/*onOpened={() => {
						this.props.actions.setGlobalState({open: this.props.globalState.open + 1});
					}}
					onClosed={() => {
						this.props.actions.setGlobalState({open: this.props.globalState.open - 1});
					}}*/
					onClose={() => this.setDialog(false)}
					title={<Labels.DateSelect/>}
					style={{background: "#fff"}}
				>
					<FlexCenter>
						<HeadingView viewKey="welcome">
							<Labels.Welcome/>,
						</HeadingView>

						<Labels.StudyPlanCustomize/>

						<Labels.TargetExamDate/>

						<div style={{margin: "0px auto"}}>
							<DatePicker
								onChange={(newDate) => this.handleChange(newDate)}
								value={(newDate && newDate.getTime()) < maxDate.getTime() ? newDate : maxDate}
								minDate={new Date()}
								maxDate={maxDate}
							/>
						</div>

						{newDate && (
							<CardView viewKey="selected">
								<DateLabel value={newDate} />
							</CardView>
						)}

						<ButtonView viewKey="submit" disabled={(!newDate)} onClick={() => this.setDate(newDate)}>
							<Labels.Welcome/>
						</ButtonView>
					</FlexCenter>
				</Dialog>

				{date ? (
					<HeadingView viewKey="main">
						{/*TODO no magic constant. Format propertly with react-intl */}
						<Label k="dateReminder.message" args={{days: ((date.getTime() - new Date().getTime()) / 8.64e7 | 0)}} v="${days} left until the exam" />

						<Button small={true} minimal={true} icon={IconNames.EDIT} onClick={() => this.setDialog(true)}/>
					</HeadingView>
				) : (
					<div style={{textAlign: "right"}}>
						<ButtonView viewKey="choose" onClick={() => this.setDialog(true)}>
							<Labels.SelectExamDate/>
						</ButtonView>
					</div>
				)}

			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/dateReminder/DateReminder.panel.tsx